"use client"

import type { TireIndustry, TireList } from "@/@types/Tire"
import { Pagination } from "../common"
import TireIndustryCard from "./TireIndustryCard"
import TireListCard from "./TireListCard"
import Search from "../ui/Search"
import { useState } from "react"

export default function TireContainer({
  tireIndustry,
  initialTireList,
  selectedSlug,
}: {
  tireIndustry: TireIndustry[]
  initialTireList: TireList
  selectedSlug?: string
}) {
  
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev)
  }

  return (
        <div className="grid lg:grid-cols-[25%_75%]">
          <div className="grid grid-cols-1 auto-rows-min">
            <Search onOpenFilters={toggleFilterModal} />
            <TireIndustryCard
              isMenuOpen={isFilterModalOpen}
              toggleMenu={toggleFilterModal}
              industries={tireIndustry}
              selectedSlug={selectedSlug}
            />
          </div>
          <div className="lg:pl-4 pt-4 lg:pt-0">
            {isLoading ? (
              <div className="flex justify-center items-center h-40">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
              </div>
            ) : (
              <>
                <TireListCard tires={initialTireList} />
                <Pagination
                  result="Llantas"
                  currentPage={initialTireList.meta.currentPage}
                  lastPage={initialTireList.meta.lastPage}
                  totalResults={initialTireList.meta.total}
                  perPage={initialTireList.meta.perPage}
                />
              </>
            )}
          </div>
        </div>
   
  )
}

